import {
    Card,
    Col,
    Row,
    Tabs,
} from 'antd';
import React, { useContext, useState } from 'react';
import { ETourType } from '../../enums/tours.enum';
import { Tour } from '../../interfaces/tours';
import { OnDemandTour, OnVisitTour } from './components';
import ToursList from './components/ToursList';
import { ToursContext } from './context/tours.context';

const { TabPane } = Tabs;

const Tours: React.FC = () => {
    const {
        loading,
        loadingMore,
        hasMore,
        setShowCreateTour,
        deleteTour,
        tours,
        updateTour,
        startEditingTour,
        fetchTours,
        fetchMoreTours,
        setTourSelected,
    } = useContext(ToursContext);

    const [activeTab, setActiveTab] = useState<string>('on-visit');

    const handleStartCreatingTour = (value: boolean) => {
        setActiveTab('on-visit');
        setShowCreateTour(value);
        setTourSelected(null);
    };

    const handleStartEditingTour = (tour: Tour) => {
        const nextTab = tour?.type === ETourType.ON_DEMAND ? 'on-demand' : 'on-visit';
        setActiveTab(nextTab);
        startEditingTour(tour);
    };

    return (
        <Row justify="space-between" align="top" gutter={[24, 24]}>
            <Col xs={24} xl={8}>
                <Card bordered>
                    <ToursList
                        tours={tours}
                        loading={loading}
                        loadingMore={loadingMore}
                        hasMore={hasMore}
                        handleStartCreatingTour={() => handleStartCreatingTour(true)}
                        onDeleteTour={deleteTour}
                        updateTour={updateTour}
                        startEditingTour={handleStartEditingTour}
                        fetchTours={fetchTours}
                        fetchMoreTours={fetchMoreTours}
                    />
                </Card>
            </Col>

            <Col xs={24} xl={16}>
                <Card bordered>
                    <Tabs activeKey={activeTab} onChange={setActiveTab}>
                        <TabPane tab="On Visit" key="on-visit">
                            <OnVisitTour />
                        </TabPane>
                        <TabPane tab="On Demand" key="on-demand">
                            <OnDemandTour />
                        </TabPane>
                    </Tabs>
                </Card>
            </Col>
        </Row>
    );
};

export default Tours;
